import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from './AuthService'; // Make sure this function checks for user authentication

const ProtectedRoute = () => {
  return isAuthenticated() ? < Outlet/> : <Navigate to="matrimonial-login" />;
};

export default ProtectedRoute;
